import React, { useState } from 'react';
import { 
  GoogleMap, 
  LoadScript, 
  Marker, 
  InfoWindow 
} from '@react-google-maps/api';
import { GOOGLE_MAPS_API_KEY } from './config';
import { useNavigate } from 'react-router-dom';

import { Trans } from 'react-i18next';
import { Button } from 'react-bootstrap';

// 1. Map container style
const containerStyle = {
  borderRadius: '5px',
  width: '100%',
  height: '500px'
};

// 2. Default center
const defaultCenter = {
  lat: 53.71925542536204,   // London
  lng:  -1.8436461004339022
}
// 3. Sample data: array of { id, name, position: {lat, lng}, description }
const locations = [
  { id: 1, name: 'St. Mary`s Ukrainian School Holland Park', position: { lat: 51.50600911016546, lng: -0.2109641045435373 }, description: <Trans ns="sateliteSchools" i18nKey={'holland preview'}/>, path: '/school/holland' },
  { id: 2, name: 'St. Mary`s Ukrainian School Wilberforce', position: { lat: 51.53205270355602, lng:-0.20852366802938807, }, description: <Trans ns="sateliteSchools" i18nKey={'wilberforce preview'}/>, path: '/school/wilberforce' },
  { id: 3, name: 'St. Mary`s Ukrainian School Glasgow', position: { lat: 55.82648944276283, lng: -4.263143188516069 }, description: <Trans ns="sateliteSchools" i18nKey={'glasgow preview'}/>, path: '/school/glasgow' },
  { id: 4, name: 'St. Mary`s Ukrainian School Richmond', position: { lat: 51.436830734203205, lng: -0.3183421275596607 }, description: <Trans ns="sateliteSchools" i18nKey={'richmond preview'}/>, path: '/school/richmond' },
  { id: 5, name: 'St. Mary`s Ukrainian School Amersham', position: { lat: 51.667554483446615, lng: -0.5937864978980109 }, description: <Trans ns="sateliteSchools" i18nKey={'amersham preview'}/>, path: '/school/amersham' },
  { id: 6, name: 'St. Mary`s Ukrainian School Cardinal', position: { lat: 51.50401774741247, lng: -0.21143296563418942 }, description: <Trans ns="sateliteSchools" i18nKey={'cardinal preview'}/>, path: '/school/cardinal' },
  { id: 7, name: 'St. Mary`s Ukrainian School Tunbridge Wells', position: { lat: 51.14085950493365, lng: 0.29427064912762907 }, description: <Trans ns="sateliteSchools" i18nKey={'tunbridge preview'}/>, path: '/school/tunbridge' },
  { id: 8, name: 'St. Mary`s Ukrainian School Merton', position: { lat: 51.404215209812044, lng: -0.15952806651973314 }, description: <Trans ns="sateliteSchools" i18nKey={'merton preview'}/>, path: '/school/merton' },
  { id: 9, name: 'St. Mary`s Ukrainian School Guildford', position: { lat: 51.23441758341411, lng: -0.5852056000000001 }, description: <Trans ns="sateliteSchools" i18nKey={'guildford preview'}/>, path: '/school/guildford' },
  { id: 10, name: 'St. Mary`s Ukrainian Tadpoles Nursery', position: { lat: 51.48449799518589, lng: -0.17808894528874566 }, description: <Trans ns="sateliteSchools" i18nKey={'nursery preview'}/>, path: '/school/nursery' },
  { id: 11, name: 'St. Mary`s Ukrainian School Hillingdon', position: { lat: 51.5391461487905, lng: -0.4454163283280806 }, description: <Trans ns="sateliteSchools" i18nKey={'hillingdon preview'}/>, path: '/school/hillingdon' },
  { id: 12, name: 'St. Mary`s Ukrainian School Kingston', position: { lat: 51.404190514215635, lng: -0.26570606564860794 }, description: <Trans ns="sateliteSchools" i18nKey={'kingston preview'}/>, path: '/school/kingston' },
  { id: 13, name: 'St. Mary`s Ukrainian School Northampton', position: { lat: 52.24263136157714, lng: -0.9422854274852228  }, description: <Trans ns="sateliteSchools" i18nKey={'northampton preview'}/>, path: '/school/northampton' },
  { id: 14, name: 'St. Mary`s Ukrainian School Woking', position: { lat: 51.30846818281583, lng: -0.5493317703953409 }, description: <Trans ns="sateliteSchools" i18nKey={'woking preview'}/>, path: '/school/woking' },
  { id: 15, name: 'St. Mary`s Ukrainian School Stratford', position: { lat: 51.54375466315271, lng: 0.008006366210047614  }, description: <Trans ns="sateliteSchools" i18nKey={'stratford preview'}/>, path: '/school/stratford' },
  
  // …add as many locations as you like, to be displayed on the map
];

function MapWithMarkers() {
  // Track which marker is “selected” (clicked)
  const [selected, setSelected] = useState(null);
  const navigate = useNavigate(); //  line to use React Router's navigation
  const handleSchoolClick = (school) => {
    navigate(school.path); // Navigate to the school's specific page
  };

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={defaultCenter}
        zoom={6}
      >
        {/** 4. Render all markers */}
        {locations.map(loc => (
          <Marker
            key={loc.id}
            position={loc.position}
            onClick={() => setSelected(loc)}
          />
        ))}

        {/** 5. If a marker is selected, show an InfoWindow */}
        {selected && (
          <InfoWindow
            position={selected.position}
            onCloseClick={() => setSelected(null)}
          >
            {/** 6. Inside you can use any JSX – here’s a Bootstrap card */}
            <div className="card" style={{ width: '12rem', height: 'fit-content' }}>
              <div className="card-body">
                <h5 className="card-title">{selected.name}</h5>
                <p className="card-text">{selected.description}</p>
                <Button
                  className="btn btn-primary btn-sm"
                  onClick={() => handleSchoolClick(selected)}
                >
                  <Trans i18nKey='visit_school'/>
                </Button>
              </div>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
}

export default React.memo(MapWithMarkers);